<div class="home-page">
  <div class="container-fluid">
    <div class="page-head home-header">
      <div class="page-head__left">
        <h1 class="page-title home-title">Painel do Dia</h1>
        <p class="text-muted mb-0 home-subtitle">Prioridades de hoje e saíde da operação.</p>
      </div>
      <div class="page-head__right">
        <span class="home-date-chip">{{ filtroData | date: 'dd/MM/yyyy' }}</span>
      </div>
    </div>

    <section class="home-filters-card">
      <div class="filter-grid">
        <label class="filter-field">
          <span>Data referência</span>
          <input type="date" [(ngModel)]="filtroData" (ngModelChange)="onFiltersChange()" />
        </label>
        <label class="filter-field">
          <span>Seguradora</span>
          <select [(ngModel)]="filtroSeguradora" (ngModelChange)="onFiltersChange()">
            <option value="">Todos</option>
            <option *ngFor="let item of seguradoras" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label class="filter-field">
          <span>Consultor</span>
          <select [(ngModel)]="filtroConsultor" (ngModelChange)="onFiltersChange()">
            <option value="">Todos</option>
            <option *ngFor="let item of consultores" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label class="filter-field">
          <span>Responsável</span>
          <select [(ngModel)]="filtroResponsavel" (ngModelChange)="onFiltersChange()">
            <option value="">Todos</option>
            <option *ngFor="let item of responsaveis" [value]="item">{{ item }}</option>
          </select>
        </label>
        <label class="filter-field filter-toggle">
          <span>Somente com risco</span>
          <input
            type="checkbox"
            [(ngModel)]="filtroSomenteRisco"
            (ngModelChange)="onFiltersChange()"
          />
        </label>
      </div>
    </section>

    <section class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-label">Orçamentos sem seguimento</div>
        <div class="kpi-value">{{ kpiSemContato }}</div>
        <span class="kpi-badge" *ngIf="kpiSemContato > 0">ATENÇÃO</span>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">Contatos pendentes hoje</div>
        <div class="kpi-value">{{ kpiContatosHoje }}</div>
        <span class="kpi-badge" *ngIf="kpiContatosHoje > 0">ATENÇÃO</span>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">WIP em produção</div>
        <div class="kpi-value">{{ kpiWip }}</div>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">WIP em atraso</div>
        <div class="kpi-value">{{ kpiWipAtraso }}</div>
        <span class="kpi-badge" *ngIf="kpiWipAtraso > 0">ATENÇÃO</span>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">Parados (>= 3 dias)</div>
        <div class="kpi-value">{{ kpiParados }}</div>
        <span class="kpi-badge" *ngIf="kpiParados > 0">ATENÇÃO</span>
      </div>
      <div class="kpi-card">
        <div class="kpi-label">Entregas nos próximos 3 dias</div>
        <div class="kpi-value">{{ kpiEntregas3Dias }}</div>
      </div>
    </section>

    <div class="tabs-pill home-tabs" role="tablist">
      <button
        class="tab-btn"
        type="button"
        [class.active]="activeTab === 'prioridades'"
        (click)="setTab('prioridades')"
      >
        Prioridades
      </button>
      <button
        class="tab-btn"
        type="button"
        [class.active]="activeTab === 'operacao'"
        (click)="setTab('operacao')"
      >
        Operação
      </button>
      <button
        class="tab-btn"
        type="button"
        [class.active]="activeTab === 'crm'"
        (click)="setTab('crm')"
      >
        CRM
      </button>
      <button
        class="tab-btn"
        type="button"
        [class.active]="activeTab === 'resumo'"
        (click)="setTab('resumo')"
      >
        Resumo
      </button>
    </div>

    <section *ngIf="activeTab === 'prioridades'" class="home-tab">
      <div class="home-section">
        <div class="home-section__header">
          <h2 class="home-section__title">Top riscos</h2>
          <span class="home-section__hint">Mistura atraso, parados, sem contato e peças</span>
        </div>

        <div class="wf-table-card" *ngIf="topRiscos.length; else noRiscos">
          <table class="wf-table">
            <thead>
              <tr>
                <th class="col-type">Tipo</th>
                <th>OS / Orçamento</th>
                <th>Cliente</th>
                <th>Placa / Veículo</th>
                <th>Etapa / Status</th>
                <th>Responsável</th>
                <th class="col-days">Dias</th>
                <th class="col-actions">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of topRiscos">
                <td>
                  <span [class]="getBadgeClass(item.tipo)">
                    {{
                      item.tipo === 'SEM_CONTATO'
                        ? 'SEM CONTATO'
                        : item.tipo === 'PECAS'
                          ? 'PEÇAS'
                          : item.tipo
                    }}
                  </span>
                </td>
                <td class="cell-strong">{{ item.referencia }}</td>
                <td class="cell-truncate">{{ item.cliente }}</td>
                <td class="cell-truncate">{{ item.veiculo }}</td>
                <td class="cell-truncate">{{ item.etapaOuStatus }}</td>
                <td class="cell-truncate">{{ item.responsavel }}</td>
                <td class="text-end">{{ item.dias }}</td>
                <td class="col-actions">
                  <button
                    class="btn btn-sm btn-primary"
                    type="button"
                    (click)="abrirItemRisco(item)"
                  >
                    Abrir
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noRiscos>
          <div class="empty-state">Sem riscos críticos para hoje.</div>
        </ng-template>
      </div>

      <div class="home-section">
        <div class="home-section__header">
          <h2 class="home-section__title">Contatos do dia</h2>
          <span class="home-section__hint">Ações planejadas para hoje</span>
        </div>

        <div class="wf-table-card" *ngIf="contatosHoje.length; else noContatos">
          <table class="wf-table">
            <thead>
              <tr>
                <th class="col-placa">Placa</th>
                <th>Canal / Hor—rio</th>
                <th>Consultor</th>
                <th class="col-actions">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of contatosHoje">
                <td class="cell-strong">{{ item.orcamento?.placa || 'Sem placa' }}</td>
                <td class="cell-truncate">{{ getContatoCanal(item) }}</td>
                <td class="cell-truncate">
                  {{ item.orcamento?.consultorResponsavel || 'Consultor' }}
                </td>
                <td class="col-actions">
                  <div class="action-buttons">
                    <button
                      class="icon-btn icon-btn--check"
                      type="button"
                      title="Gerar OS"
                      aria-label="Gerar OS"
                      (click)="abrirModalGerarOS(item)"
                    >
                      <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path
                          d="M4 10.5l3.2 3.2L16 5.8"
                          stroke="currentColor"
                          stroke-width="1.8"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      class="icon-btn icon-btn--edit"
                      type="button"
                      title="Editar contato"
                      aria-label="Editar contato"
                      (click)="abrirModalContato(item)"
                    >
                      <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                        <path
                          d="M4 13.8v2.2h2.2l7-7-2.2-2.2-7 7Z"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M11.4 4.6l2.2 2.2"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noContatos>
          <div class="empty-state">Nenhum contato pendente para hoje.</div>
        </ng-template>
      </div>
    </section>

    <section *ngIf="activeTab === 'operacao'" class="home-tab">
      <div class="home-two-col">
        <div class="home-section">
          <div class="home-section__header">
            <h2 class="home-section__title">WIP por etapa</h2>
            <span class="home-section__hint">Distribuição operacional</span>
          </div>

          <div class="stage-grid" *ngIf="wipPorEtapa.length; else noWip">
            <div class="stage-card" *ngFor="let etapa of wipPorEtapa">
              <div class="stage-title">{{ etapa.etapa }}</div>
              <div class="stage-value">{{ etapa.total }}</div>
              <div class="stage-chips">
                <span class="chip chip--danger" *ngIf="etapa.atrasados > 0"
                  >Atrasados: {{ etapa.atrasados }}</span
                >
                <span class="chip chip--warn" *ngIf="etapa.parados > 0"
                  >Parados: {{ etapa.parados }}</span
                >
              </div>
              <div class="stage-meta">Idade média: {{ etapa.mediaDias }} dias</div>
            </div>
          </div>
          <ng-template #noWip>
            <div class="empty-state">Nenhum WIP encontrado.</div>
          </ng-template>
        </div>

        <div class="home-section">
          <div class="home-section__header">
            <h2 class="home-section__title">Fila de peças</h2>
            <span class="home-section__hint">Etapa Compra de Peças</span>
          </div>

          <div class="wf-table-card" *ngIf="filaPecas.length; else noPecas">
            <table class="wf-table">
              <thead>
                <tr>
                  <th>OS</th>
                  <th>Veículo</th>
                  <th class="col-days">Dias na etapa</th>
                  <th>Responsável</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let workflow of filaPecas">
                  <td class="cell-strong">{{ workflow.osNumero }}</td>
                  <td class="cell-truncate">{{ getVeiculoLabel(workflow) }}</td>
                  <td class="text-end">
                    {{ getDiasNaEtapa(workflow, parseInputDate(filtroData)) }}
                  </td>
                  <td class="cell-truncate">{{ workflow.responsavelAtual }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noPecas>
            <div class="empty-state">Sem itens aguardando peças.</div>
          </ng-template>
        </div>
      </div>
    </section>

    <section *ngIf="activeTab === 'crm'" class="home-tab">
      <div class="home-two-col">
        <div class="home-section">
          <div class="home-section__header">
            <h2 class="home-section__title">Funil rápido de orçamentos</h2>
            <button class="btn btn-primary" type="button" (click)="goToCrm()">Abrir CRM</button>
          </div>

          <div class="funil-grid">
            <div
              class="funil-card"
              *ngFor="let status of funilResumo"
              [ngClass]="getStatusClass(status.status)"
            >
              <div class="funil-title">{{ status.status }}:{{ status.total }}</div>

              <div class="funil-meta" style="display: block">
                {{ status.valor | currency: 'BRL' : 'symbol' : '1.0-0' }}
              </div>
            </div>
          </div>
        </div>

        <div class="home-section">
          <div class="home-section__header">
            <h2 class="home-section__title">Sem contato / em risco</h2>
            <span class="home-section__hint">Status ativos sem ação</span>
          </div>

          <div class="wf-table-card" *ngIf="orcamentosRisco.length; else noRiscoCrm">
            <table class="wf-table">
              <thead>
                <tr>
                  <th>Orçamento</th>
                  <th>Cliente</th>
                  <th>Veículo</th>
                  <th>Status</th>
                  <th class="col-days">Dias sem contato</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let orcamento of orcamentosRisco">
                  <td class="cell-strong">{{ getOrcamentoNumero(orcamento) }}</td>
                  <td class="cell-truncate">{{ orcamento.clienteNome }}</td>
                  <td class="cell-truncate">
                    {{ orcamento.placa }} · {{ orcamento.marca }} {{ orcamento.modelo }}
                  </td>
                  <td>
                    <span [class]="getStatusClass(orcamento.statusAtendimento || 'Aberto')">
                      {{ orcamento.statusAtendimento || 'Aberto' }}
                    </span>
                  </td>
                  <td class="text-end">{{ orcamento.diasSemContato }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noRiscoCrm>
            <div class="empty-state">Sem orçamentos em risco.</div>
          </ng-template>
        </div>
      </div>
    </section>

    <section *ngIf="activeTab === 'resumo'" class="home-tab">
      <div class="home-summary-grid">
        <div class="summary-card">
          <div class="summary-title">Entradas vs Saídas (Últimos 7 dias)</div>
          <div class="summary-metrics">
            <div>
              <div class="summary-label">Entradas</div>
              <div class="summary-value">{{ kpiEntradas7Dias }}</div>
            </div>
            <div>
              <div class="summary-label">Saídas</div>
              <div class="summary-value">{{ kpiSaidas7Dias }}</div>
            </div>
            <div>
              <div class="summary-label">Saldo</div>
              <div class="summary-value">{{ kpiSaldo7Dias }}</div>
            </div>
          </div>
          <div
            class="summary-hint"
            [class.positive]="kpiSaldo7Dias < 0"
            [class.negative]="kpiSaldo7Dias > 0"
          >
            {{
              kpiSaldo7Dias > 0
                ? 'WIP tende a crescer.'
                : kpiSaldo7Dias < 0
                  ? 'WIP tende a reduzir.'
                  : 'Saldo neutro.'
            }}
          </div>
        </div>

        <div class="summary-card">
          <div class="summary-title">Etapas mais lentas (Top 3)</div>
          <div class="summary-list" *ngIf="etapasLentas.length; else noEtapas">
            <div class="summary-row" *ngFor="let etapa of etapasLentas">
              <div class="summary-name">{{ etapa.etapa }}</div>
              <div class="summary-meta">Média {{ etapa.media }}d · P95 {{ etapa.p95 }}d</div>
            </div>
          </div>
          <ng-template #noEtapas>
            <div class="empty-state">Sem dados suficientes.</div>
          </ng-template>
        </div>

        <div class="summary-card">
          <div class="summary-title">Maiores parados</div>
          <div class="summary-list" *ngIf="maioresParados.length; else noParados">
            <div class="summary-row" *ngFor="let workflow of maioresParados">
              <div class="summary-name">{{ workflow.osNumero }} · {{ workflow.placa }}</div>
              <div class="summary-meta">
                {{ getEtapaNome(workflow) }} · {{ workflow.diasParado }} dias
              </div>
            </div>
          </div>
          <ng-template #noParados>
            <div class="empty-state">Sem parados relevantes.</div>
          </ng-template>
        </div>
      </div>
    </section>
  </div>
</div>

<app-lead-contato-modal
  [aberto]="modalContatoAberta"
  [lead]="selectedLead"
  (fechar)="fecharModalContato()"
  (encerrar)="encerrarContato()"
  (salvar)="salvarContato($event)"
></app-lead-contato-modal>

<div class="modal-backdrop" *ngIf="gerarOsOpen" (click)="fecharModalGerarOS()"></div>
<div class="modal" *ngIf="gerarOsOpen" (click)="fecharModalGerarOS()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div>
        <h5 class="modal-title">Gerar OS</h5>
        <div class="text-muted">{{ selectedOsLead?.placa }}</div>
      </div>
      <button type="button" class="btn-close" (click)="fecharModalGerarOS()"></button>
    </div>

    <div class="modal-grid">
      <div class="field-box">
        <div class="field-label">Placa</div>
        <div class="field-value">{{ selectedOsLead?.placa }}</div>
      </div>
      <div class="field-box">
        <div class="field-label">Marca</div>
        <div class="field-value">{{ selectedOsLead?.marca }}</div>
      </div>
      <div class="field-box">
        <div class="field-label">Modelo</div>
        <div class="field-value">{{ selectedOsLead?.modelo }}</div>
      </div>
      <div class="field-box">
        <div class="field-label">Cliente</div>
        <div class="field-value">{{ selectedOsLead?.clienteNome }}</div>
      </div>
      <div class="field-box">
        <div class="field-label">Consultor</div>
        <div class="field-value">{{ selectedOsLead?.consultorResponsavel }}</div>
      </div>
      <div class="field-box">
        <div class="field-label">Número OS</div>
        <input class="form-control" type="text" [(ngModel)]="osNumero" />
      </div>
    </div>

    <div class="modal-actions">
      <button class="btn btn-muted btn-pill" (click)="fecharModalGerarOS()">Cancelar</button>
      <button class="btn btn-brand btn-pill" (click)="confirmarGerarOS()">Confirmar</button>
    </div>
  </div>
</div>
